import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import theme from '../../../theme';
import Repeat from '../Repeat';

const progress = keyframes`
  0% {
    left: -500px
  }
  100% {
    left: 100%
  }
`;
const SkeletonBlock = styled.span
  .attrs((props) => ({
    style: {
      width: props.width,
      height: props.height,
      borderRadius: props.borderRadius,
      backgroundColor: props.color,
      ...props.style,
    },
  }))`
  display: inline-block;
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 500px;
    top: 0;
    left: -500px;
    background-image: linear-gradient(90deg, rgba(255,255,255, 0), rgba(255,255,255, 0.6), rgba(255,255,255, 0));
    ${(props) => props.isAnimated && css`
      animation: ${progress} 1.2s ease-in-out infinite;
    `};
    
  }
`;

const Skeleton = ({
  width,
  height,
  widthRandomness,
  heightRandomness,
  borderRadius,
  color,
  count,
  isAnimated,
  style,
}) => {
  const w = parseFloat(width);
  const h = parseFloat(height);
  const wm = width.toString().replace(/\d+/g, '');
  const hm = height.toString().replace(/\d+/g, '');

  return (
    <Repeat
      times={count}
      wrapper={Fragment}
      render={(i) => {
        const width = `${w - (Math.random() * w * widthRandomness)}${wm}`;
        const height = `${h - (Math.random() * h * heightRandomness)}${hm}`;
        return (
          <Fragment key={i}>
            <SkeletonBlock
              key={i}
              isAnimated={isAnimated}
              width={width}
              height={height}
              borderRadius={borderRadius}
              color={color}
              style={style}
            >
              &zwnj;
            </SkeletonBlock>
            {(i !== count - 1) && <br key={`br-${i}`} />}
          </Fragment>
        );
      }}
    />
  );
};
Skeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  widthRandomness: PropTypes.number,
  heightRandomness: PropTypes.number,
  borderRadius: PropTypes.string,
  color: PropTypes.string,
  count: PropTypes.number,
  isAnimated: PropTypes.bool,
  style: PropTypes.objectOf(PropTypes.any),
};
Skeleton.defaultProps = {
  width: '150px',
  height: '100%',
  widthRandomness: 0.25,
  heightRandomness: 0,
  borderRadius: '5px',
  color: theme.colors.light,
  count: 1,
  isAnimated: true,
  style: {},
};

export default Skeleton;
